<template>
    <div class="card">
        <div class="card-body d-flex flex-column align-items-center justify-content-center">
            <img class="dashboard-image mt-10" src="/images/dashboard.png" alt="Dashboard">
            <span class="dashboard-title mt-3 mb-10">{{ $t('pages.dashboard.title') }}</span>
        </div>
    </div>
    <!--
    <div class="row g-5 mt-5">
        <div class="col-lg-3">
            <router-link to="/customer" class="card bg-dark hoverable card-xl-stretch mb-xl-8">
                <div class="card-body">
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">

                    </span>
                    <span class="icon svg-icon svg-icon-3x svg-icon-white">
                        <inline-svg src="/media/icons/duotune/communication/com006.svg"/>
                    </span>
                    <div class="text-gray-100 fw-bolder fs-2 mb-2 mt-5">3752</div>
                    <div class="fw-bold text-gray-100">{{ $t('pages.dashboard.customer.title') }}</div>
                </div>
            </router-link>
        </div>

        <div class="col-lg-3">
            <router-link to="/customer" class="card bg-info hoverable card-xl-stretch mb-xl-8">
                <div class="card-body">
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">

                    </span>
                    <span class="icon svg-icon svg-icon-3x svg-icon-white">
                        <inline-svg src="/media/icons/duotune/communication/com006.svg"/>
                    </span>
                    <div class="text-gray-100 fw-bolder fs-2 mb-2 mt-5">3752</div>
                    <div class="fw-bold text-gray-100">{{ $t('pages.dashboard.customer.title') }}</div>
                </div>
            </router-link>
        </div>

        <div class="col-lg-3">
            <router-link to="/customer" class="card bg-warning hoverable card-xl-stretch mb-xl-8">
                <div class="card-body">
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">

                    </span>
                    <span class="icon svg-icon svg-icon-3x svg-icon-white">
                        <inline-svg src="/media/icons/duotune/communication/com006.svg"/>
                    </span>
                    <div class="text-gray-100 fw-bolder fs-2 mb-2 mt-5">3752</div>
                    <div class="fw-bold text-gray-100">{{ $t('pages.dashboard.customer.title') }}</div>
                </div>
            </router-link>
        </div>

        <div class="col-lg-3">
            <router-link to="/customer" class="card bg-danger hoverable card-xl-stretch mb-xl-8">
                <div class="card-body">
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">

                    </span>
                    <span class="icon svg-icon svg-icon-3x svg-icon-white">
                        <inline-svg src="/media/icons/duotune/communication/com006.svg"/>
                    </span>
                    <div class="text-gray-100 fw-bolder fs-2 mb-2 mt-5">3752</div>
                    <div class="fw-bold text-gray-100">{{ $t('pages.dashboard.customer.title') }}</div>
                </div>
            </router-link>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Test</h3>
                </div>
                <div class="card-body">
                    test2
                </div>
            </div>
        </div>
    </div>
    -->
</template>

<script>
import Plate from "@/components/plate/Plate.vue";

export default {
    name: "dashboard",
    components: {
        Plate
    },
    computed: {

    },
    mounted() {
        this.setCurrentPageTitle(this.$t('menu.dashboard'));
    }
}
</script>